import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReactVimeo from 'components/consumer/ReactVimeo';
import RatioContainer from 'components/consumer/RatioContainer';
import WistiaVideoPlayer from 'components/consumer/WistiaVideoPlayer';
const LivestreamVideoPlayer = t0 => {
  const $ = _c(22);
  const {
    fullWidth: t1,
    videoId,
    videoType
  } = t0;
  const fullWidth = t1 === undefined ? false : t1;
  const videoPlayerRef = useRef(null);
  if (videoType !== "vimeo" && videoType !== "wistia") {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      videoPlayerRef.current.scrollIntoView({
        behavior: "smooth"
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const scrollPlayerIntoView = t2;
  let t3;
  if ($[1] !== videoId) {
    t3 = videoId ? videoId.replace("/manage/videos", "") : videoId;
    $[1] = videoId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const vimeoVideoId = t3;
  let t4;
  if ($[3] !== fullWidth) {
    t4 = classNames("flex-1", {
      "bg-black flex justify-center": fullWidth
    });
    $[3] = fullWidth;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== fullWidth) {
    t5 = classNames("scroll-mt-5", {
      "flex-1 lg:max-w-[calc(93.334vw_-_3rem_-_233px)] min-[1500px]:max-w-[calc(1167px_-_3rem)]": fullWidth
    });
    $[5] = fullWidth;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== videoType || $[8] !== vimeoVideoId) {
    t6 = videoType === "vimeo" && <ReactVimeo video={vimeoVideoId} className="flex w-full" onLoaded={scrollPlayerIntoView} />;
    $[7] = videoType;
    $[8] = vimeoVideoId;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== videoId || $[11] !== videoType) {
    t7 = videoType === "wistia" && <WistiaVideoPlayer videoId={videoId} className="LivestreamVideoPlayer__video--wistia" onLoaded={scrollPlayerIntoView} />;
    $[10] = videoId;
    $[11] = videoType;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <RatioContainer className="[&_iframe]:absolute [&_iframe]:top-0 [&_iframe]:bottom-0 [&_iframe]:left-0 [&_iframe]:right-0 [&_iframe]:w-full [&_iframe]:h-full" ratio={0.5625}><div>{t6}{t7}</div></RatioContainer>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t5 || $[17] !== t8) {
    t9 = <div className={t5} ref={videoPlayerRef}>{t8}</div>;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t4 || $[20] !== t9) {
    t10 = <div className={t4}>{t9}</div>;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
LivestreamVideoPlayer.propTypes = {
  fullWidth: PropTypes.bool,
  videoId: PropTypes.string,
  videoType: PropTypes.oneOf(['vimeo', 'wistia'])
};
export default LivestreamVideoPlayer;